import { NgModule } from '@angular/core';

import { ThemeModule } from '../../@theme/theme.module';
import { LoginComponent } from './login.component';
import {RankingLinkComponent} from '../ranking-link/ranking-link.component'
import {MainPipe} from '../../pipes/main-pipe.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BirthdayLinkComponent } from '../birthday-link/birthday-link.component';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
@NgModule({
  imports: [
    ThemeModule,
    MainPipe,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
  })
  ],
  declarations: [
    LoginComponent,
    RankingLinkComponent,
    BirthdayLinkComponent
  ],
})
export class LoginModule { }
